import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

// ✅ Fix Chrome "ResizeObserver loop completed with undelivered notifications" warning
const resizeObserverErr = (e) =>
  e.message === "ResizeObserver loop completed with undelivered notifications.";

window.addEventListener("error", (e) => {
  if (resizeObserverErr(e)) {
    e.stopImmediatePropagation();
  }
});

window.addEventListener("unhandledrejection", (e) => {
  if (resizeObserverErr(e.reason)) {
    e.preventDefault();
  }
});

// ✅ REGISTER service worker so the app is installable (PWA "Install" prompt)
// NOTE: The old code here used to UNREGISTER all service workers, which is
// what removed the install prompt. This now registers it properly.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        console.log("✅ Service worker registered:", reg.scope);
      })
      .catch((err) => {
        console.error("❌ Service worker registration failed:", err);
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
